export const getIascFromQuery = ()=>{
    const query = new URLSearchParams(location.search);
    return query.get('iasc');
};
